export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"60d350285179a1001e683feb",
				"60d350285179a1001e683fed",
				"60d4673ad3b536001e86f530",
				"60d6ed543f4eb1001ea27322"
			]
		},
		"60d350285179a1001e683feb": {
			"id": "60d350285179a1001e683feb",
			"name": "404",
			"pageUrl": "404"
		},
		"60d350285179a1001e683fed": {
			"id": "60d350285179a1001e683fed",
			"name": "Home",
			"pageUrl": "index"
		},
		"60d4673ad3b536001e86f530": {
			"id": "60d4673ad3b536001e86f530",
			"pageUrl": "templates",
			"name": "How It works"
		},
		"60d6ed543f4eb1001ea27322": {
			"id": "60d6ed543f4eb1001ea27322",
			"pageUrl": "case-studies",
			"name": "#MadeByWetar"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {
			"title": "Wetar",
			"description": "starts at Rs.99\nWebsite , tamilnadu, pondicherry, tamil",
			"favicon_32px": "https://uploads.quarkly.io/60d350285179a1001e683fe8/images/Untitled%20story%20%2817%29.png?v=2021-09-04T16:14:25.304Z",
			"favicon_apple_152px": "https://uploads.quarkly.io/60d350285179a1001e683fe8/images/Untitled%20story%20%2817%29.png?v=2021-09-04T16:14:25.304Z",
			"favicon_win10_270px": "https://uploads.quarkly.io/60d350285179a1001e683fe8/images/Untitled%20story%20%2817%29.png?v=2021-09-04T16:14:25.304Z",
			"background_win10": ""
		}
	}
}